import { createAction, handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
import React from "react";

// action types
const SET_USER = 'myInfo/SET_USER';
const SET_RIVAL_COMPANY_URLS = 'myInfo/SET_RIVAL_COMPANY_URLS';
const UPDATE_RIVAL_COMPANY_URL = 'myInfo/UPDATE_RIVAL_COMPANY_URL';
const SET_INPUT_RIVAL_COMPANY_URL = 'myInfo/SET_INPUT_RIVAL_COMPANY_URL';
const SET_COUPONS = 'myInfo/SET_COUPONS';
const SET_PHONE_REGISTER_NAME = 'myInfo/SET_PHONE_REGISTER_NAME';
const SET_PHONE_REGISTER_LIST = 'myInfo/SET_PHONE_REGISTER_LIST';
const INIT_PHONE_REGISTER = 'myInfo/INIT_PHONE_REGISTER';

const SET_PHONE_LIST_PAGE = 'sentMessage/SET_PHONE_LIST_PAGE';
const SET_PHONE_LIST_SIZE = 'sentMessage/SET_PHONE_LIST_SIZE';
const SET_PHONE_LIST_TOTAL = 'myInfo/SET_PHONE_LIST_TOTAL';
const SET_PHONE_LIST = 'myInfo/SET_PHONE_LIST';
const SET_PHONE_UID = 'myInfo/SET_PHONE_UID';

const SET_WEBAPP_LIST_PAGE = 'myInfo/SET_WEBAPP_LIST_PAGE';
const SET_WEBAPP_LIST_SIZE = 'myInfo/SET_WEBAPP_LIST_SIZE';
const SET_WEBAPP_LIST_TOTAL = 'myInfo/SET_WEBAPP_LIST_TOTAL';
const SET_WEBAPP_LIST = 'myInfo/SET_WEBAPP_LIST';

// action creators
export const setUser = createAction(SET_USER);
export const setRivalCompanyUrls = createAction(SET_RIVAL_COMPANY_URLS);
export const updateRivalCompanyUrl = createAction(UPDATE_RIVAL_COMPANY_URL);
export const setInputRivalCompanyUrl = createAction(SET_INPUT_RIVAL_COMPANY_URL);
export const setCoupons = createAction(SET_COUPONS);
export const setPhoneRegisterName = createAction(SET_PHONE_REGISTER_NAME);
export const setPhoneRegisterList = createAction(SET_PHONE_REGISTER_LIST);
export const initPhoneRegister = createAction(INIT_PHONE_REGISTER);
export const setPhoneListPage = createAction(SET_PHONE_LIST_PAGE);
export const setPhoneListSize = createAction(SET_PHONE_LIST_SIZE);
export const setPhoneListTotal = createAction(SET_PHONE_LIST_TOTAL);
export const setPhoneList = createAction(SET_PHONE_LIST);
export const setPhoneUid = createAction(SET_PHONE_UID);
export const setWebappListPage = createAction(SET_WEBAPP_LIST_PAGE);
export const setWebappListSize = createAction(SET_WEBAPP_LIST_SIZE);
export const setWebappListTotal = createAction(SET_WEBAPP_LIST_TOTAL);
export const setWebappList = createAction(SET_WEBAPP_LIST);

// initial state
const initialState = Map( {
    user: {},
    rivalCompanyUrls: [],
    inputRivalCompanyUrl: 'https://',
    coupons: [],

    businessFile: false,
    changeAuth: false,
    changePass: false,
    couponList: false,

    phoneUid: 0,
    phoneRegisterName: "",
    phoneRegisterList: ["","","","","","","","","",""],

    phoneListPage: 1,
    phoneListSize: 10,
    phoneListTotal: 0,
    phoneList: [],

    webappListPage: 1,
    webappListSize: 10,
    webappListTotal: 0,
    webappList: [],
})

// reducer
export default handleActions({
    [SET_USER]: (state, action) => {
        const user = action.payload;
        return state.set('user', user);
    },
    [SET_RIVAL_COMPANY_URLS]: (state, action) => {
        const array = action.payload;
        return state.set('rivalCompanyUrls', array);
    },
    [UPDATE_RIVAL_COMPANY_URL]: (state, action) => {
        const data = action.payload;
        return state.setIn(['rivalCompanyUrls', data.index], data.value);
    },
    [SET_INPUT_RIVAL_COMPANY_URL]: (state, action) => {
        const inputRivalCompanyUrl = action.payload;
        return state.set('inputRivalCompanyUrl', inputRivalCompanyUrl);
    },
    [SET_COUPONS]: (state, action) => {
        const coupons = action.payload;
        return state.set('coupons', coupons);
    },
    [SET_PHONE_REGISTER_NAME]: (state, action) => {
        const phoneRegisterName = action.payload;
        return state.set('phoneRegisterName', phoneRegisterName);
    },
    [SET_PHONE_REGISTER_LIST]: (state, action) => {
        const data = action.payload;
        return state.setIn(['phoneRegisterList', data.index], data.value);
    },
    [INIT_PHONE_REGISTER]: (state, action) => {
        return state
            .set('phoneUid', 0)
            .set('phoneRegisterName', '')
            .set('phoneRegisterList', ["","","","","","","","","",""]);
    },
    [SET_PHONE_LIST_PAGE]: (state, action) => {
        const phoneListPage = action.payload;
        return state.set('phoneListPage', phoneListPage);
    },
    [SET_PHONE_LIST_SIZE]: (state, action) => {
        const phoneListSize = action.payload;
        return state.set('phoneListSize', phoneListSize);
    },
    [SET_PHONE_LIST_TOTAL]: (state, action) => {
        const phoneListTotal = action.payload;
        return state.set('phoneListTotal', phoneListTotal);
    },
    [SET_PHONE_LIST]: (state, action) => {
        const phoneList = action.payload;
        return state.set('phoneList', phoneList);
    },
    [SET_PHONE_UID]: (state, action) => {
        const phoneUid = action.payload;
        return state.set('phoneUid', phoneUid);
    },
    [SET_WEBAPP_LIST_PAGE]: (state, action) => {
        const webappListPage = action.payload;
        return state.set('webappListPage', webappListPage);
    },
    [SET_WEBAPP_LIST_SIZE]: (state, action) => {
        const webappListSize = action.payload;
        return state.set('webappListSize', webappListSize);
    },
    [SET_WEBAPP_LIST_TOTAL]: (state, action) => {
        const webappListTotal = action.payload;
        return state.set('webappListTotal', webappListTotal);
    },
    [SET_WEBAPP_LIST]: (state, action) => {
        const webappList = action.payload;
        return state.set('webappList', webappList);
    },
}, initialState)
